(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ParaBosquelimo_1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var externals = document.querySelectorAll('[data-pbl-external]');

  // How much page-scroll (in viewport-heights) is needed to go through the whole gallery.
  // Bigger number = slower, more gradual movement. Tune this if it still feels fast/slow.
  var SCROLL_DISTANCE_VH = 1;

  // How quickly the visible position "catches up" to the target each frame (0-1).
  // Smaller = smoother/slower easing, bigger = snappier/more direct.
  var EASING = 0.12;

  externals.forEach(function (external) {
    var scrollWrapper = external.querySelector('[data-pbl-scroll]');
    if (!scrollWrapper) return;

    var current = null;

    function getTargetScrollTop() {
      var rect = external.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      var maxScroll = scrollWrapper.scrollHeight - scrollWrapper.clientHeight;
      if (maxScroll <= 0) return 0;

      var scrollDistance = viewportHeight * SCROLL_DISTANCE_VH;
      var elementCenter = rect.top + rect.height / 2;
      var viewportCenter = viewportHeight / 2;

      // progress = 0.5 when the section is centered in the viewport, moving toward 0/1
      // as the user scrolls scrollDistance/2 above/below that point — independent of
      // the box's own (smaller, mobile-friendly) height.
      var progress = 0.5 + (viewportCenter - elementCenter) / scrollDistance;
      progress = Math.max(0, Math.min(1, progress));

      return progress * maxScroll;
    }

    function loop() {
      var target = getTargetScrollTop();
      if (current === null) current = target;
      current += (target - current) * EASING;
      scrollWrapper.scrollTop = current;
      window.requestAnimationFrame(loop);
    }

    window.requestAnimationFrame(loop);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["galeria-parallax"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Quanto scroll da página (em alturas de tela) percorre a galeria inteira. Maior = mais lento.
  var SCROLL_DISTANCE_VH = 1;
  // Suavização (0-1). Menor = mais suave.
  var EASING = 0.12;

  function init(external) {
    if (!external || external.dataset.gpReady) return;
    var track = external.querySelector('[data-gp-scroll]');
    if (!track) return;
    external.dataset.gpReady = 'true';

    var current = null;

    function target() {
      var rect = external.getBoundingClientRect();
      var vh = window.innerHeight;
      var maxScroll = track.scrollHeight - track.clientHeight;
      if (maxScroll <= 0) return 0;

      var progress = 0.5 + (vh / 2 - (rect.top + rect.height / 2)) / (vh * SCROLL_DISTANCE_VH);
      progress = Math.max(0, Math.min(1, progress));
      return progress * maxScroll;
    }

    function loop() {
      if (!document.body.contains(external)) return; // seção removida no editor
      var t = target();
      if (current === null) current = t;
      current += (t - current) * EASING;
      track.scrollTop = current;
      window.requestAnimationFrame(loop);
    }

    window.requestAnimationFrame(loop);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-gp-external]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Reinicializa quando a seção é editada no customizador
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customers-login"]) return;
  try {
    
  const handleActiveForm = () => {
    const goToRecoveryFormButton = $('[data-action="toggle-recover-form"]');
    const goToLoginFormButton = $('[data-action="toggle-login-form"]');

    const toggleFormsVisibility = () => {
      const recoveryForm = $('#recover_customer_password')
      const loginForm = $('#customer_login')
      const loginFormIsVisible = loginForm.is(':visible');

      if(loginFormIsVisible) {
        loginForm.hide()
        recoveryForm.fadeIn(500)
      } else {
        recoveryForm.hide()
        loginForm.fadeIn(500)
      }
    }

    goToLoginFormButton.on('click', toggleFormsVisibility)
    goToRecoveryFormButton.on('click', toggleFormsVisibility )
  }

  $(window).on('load', function() {
    handleActiveForm()
  })

  } catch(e) { console.error(e); }
})();
})();
